import { ChangeDetectorRef, Component, inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BaseSiteService } from '@spartacus/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';
import { CountryService } from '../../site-context-selector/country.service';
import { KbCurrencyService } from 'src/app/services/sapSpartacus/kbCurrencyService/kbCurrency-service.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-country-selector-page',
  templateUrl: './counrty-selector-page.component.html',
  styleUrls: ['./counrty-selector-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CountrySelectorPageComponent {
  countrySelectorData: any;
  countryIsoCode: any;
  MediaUrl: string;
  cd: any;
  displayIsocodes: string[];
  langIsocodes: string[];
  baseSite: string;
  baseUrl: string;
  selectedCountry: string;
  canLogOut: boolean = false;
  countrySelectorData$: Observable<any> = this.countrySelectorService.getCountrySelectorData(true);
  environment = this.environmentService.getConfig();
  platformId = inject(PLATFORM_ID);
  private readonly destroy$ = new Subject<void>();
  constructor(
    private countrySelectorService: CountrySelectorService,
    private router: Router,
    public cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private authService: AuthService,
    private baseSiteService: BaseSiteService,
    private environmentService: EnvironmentService,
    private currencyService: KbCurrencyService,
    private countryContextService: CountryService
  ) { }

  ngOnInit() {
    this.baseSiteService.getActive().pipe(takeUntil(this.destroy$)).subscribe((baseSiteName) => {
      this.baseSite = baseSiteName;
    });
    this.countryContextService.getActive().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.selectedCountry = res;
    });
  }

  getCountrySelectorData() {
    this.countrySelectorService.getCountrySelectorData().pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        if (data) {
          this.countrySelectorData = data;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching Country Selector data:', error);
      }
    );
  }

  generateHrefLink(
    isocode: string,
    currencyIsoCode: string,
    countryIsoCode: string,
    displayIsoCode: string,
    mediaUrl: any,
    baseSite: any,
    event: Event
  ): void {
    event.preventDefault();
    if (baseSite === 'EMEA') {
      this.baseUrl = this.environment.emeaStoreUrl;
    } else if (baseSite === 'NA') {
      this.baseUrl = this.environment.naStoreUrl;
    } else {
      this.baseUrl = this.environment.apacStoreUrl;
    }
    if (this.selectedCountry != countryIsoCode) {
      this.isLoggedIn();
    }
    if (this.baseSite === baseSite) {
      const cookiesData = {
        countryIsoCodeNA: countryIsoCode,
        displayIsoCodeNA: displayIsoCode,
      };
      if (this.canLogOut) {
        (cookiesData['languageIsoCodeNA'] = isocode), (cookiesData['defaultCurrencyNA'] = currencyIsoCode);
      }
      this.cookieService.setCookies(cookiesData);
      this.currencyService.setAllThree(countryIsoCode, isocode, currencyIsoCode);
      this.router.navigate(['/']);
    } else {
      const url = `${this.baseUrl}/${countryIsoCode}/${isocode}/${currencyIsoCode}/`;
      if (isPlatformBrowser(this.platformId)) {
        window.open(url, '_blank');
      }
    }
  }

  getHrefLink(uid, isocode, currencyIsocode, countryIsoCode, baseSite): string {
    let url;
    if (baseSite === 'EMEA') {
      this.baseUrl = this.environment.emeaStoreUrl;
    } else if (baseSite === 'NA') {
      this.baseUrl = this.environment.naStoreUrl;
    } else {
      this.baseUrl = this.environment.apacStoreUrl;
    }
    if (this.baseSite === baseSite) {
      url = `/${uid}/${isocode}/${currencyIsocode}`;
    } else {
      url = `${this.baseUrl}/${countryIsoCode}/${isocode}/${currencyIsocode}`;
    }
    return url;
  }

  isLoggedIn() {
    this.authService.isUserLoggedIn().subscribe((isLogged) => {
      if (isLogged) {
        this.canLogOut = isLogged;
      }
    });
  }

  ngOnDestroy() {
    if (this.canLogOut) {
      this.authService.coreLogout();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
